import { connect } from 'react-redux';

import { getProjectDepDefaultAuthRoute, IApplicationState } from '@store';
import RoutesSwitch, {
  RoutesSwitchStateProps,
} from '../components/routes/RoutesSwitch';

interface RoutesSwitchStateToProps
  extends Pick<
    IApplicationState,
    'authentication' | 'error' | 'projectPicker'
  > {}

const mapStateToProps = ({
  authentication,
  error,
  projectPicker,
}: RoutesSwitchStateToProps): RoutesSwitchStateProps => {
  return {
    status: authentication.status,
    errors: error.errors,
    user: authentication.user,
    projectDepDefaultAuthRoute: getProjectDepDefaultAuthRoute(projectPicker),
    getProjectsStatus: projectPicker.getProjectsStatus,
  };
};

export default connect(mapStateToProps)(RoutesSwitch);
